module.exports = __webpack_public_path__ + "static/img/invite22.40f39de.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/invite22.png
// module id = 913
// module chunks = 1